import React, {useState} from "react";
import StudentSurveyTemplate from "./StudentSurveyTemplate";
import QuestionBank from "./QuestionBank";
import LandingPage from "./LandingPage";
import {hot} from "react-hot-loader";
import PropTypes from "prop-types";
import {momentFormatForExtJSDateFormat} from "utils/time";
import Toast from "common/Toast";

//Tenant Admins can configure multiple surveys for students
const App = ({tenantDateFormat}) => {
    const [state, setState] = useState({displayView: 'landingPage'})
    const [toastMsg, setToastMsg] = useState(null)
    const createSurvey = () => {
        setState({displayView: 'newSurvey'})
    }

    const editSurvey = (surveyId) => {
        setState({displayView: 'editSurvey', surveyId})
    }

    const duplicateTemplate = (surveyId) => {
        setState({displayView: 'duplicateTemplate', surveyId})
    }

    const viewQuestionBank = () => {
        setState({displayView: 'questionBank'})
    }

    const backToLanding = () => {
        setState({displayView: 'landingPage'})
    }

    const getBody = () => {
        switch(state.displayView) {
            case "landingPage":
                return <LandingPage createSurvey={createSurvey}
                                    duplicateTemplate={duplicateTemplate}
                                    displayToast={(msg) => setToastMsg(msg)}
                                    editSurvey={editSurvey}
                                    tenantDateFormat={momentFormatForExtJSDateFormat(tenantDateFormat)}
                                    viewQuestionBank={viewQuestionBank} />
            case "newSurvey": return <StudentSurveyTemplate cancel={backToLanding} displayToast={(msg) => setToastMsg(msg)} />
            case "editSurvey": return <StudentSurveyTemplate surveyTemplateId={state.surveyId} cancel={backToLanding} displayToast={(msg) => setToastMsg(msg)} />
            case "duplicateTemplate":
                return <StudentSurveyTemplate isCopy={true}
                                              surveyTemplateId={state.surveyId}
                                              cancel={backToLanding}
                                              displayToast={(msg) => setToastMsg(msg)} />
            case "questionBank": return <QuestionBank back={backToLanding} />
        }
    }

    return(
        <>
            { getBody() }
            { toastMsg !== null && <Toast message={toastMsg} onTimeout={() => setToastMsg(null)} /> }
        </>
    )
}

App.defaultProps = {
    tenantDateFormat: 'm-d-Y'
}

App.propTypes = {
    tenantDateFormat: PropTypes.string.isRequired
}

export default hot(module)(App);

